// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-nav-scroll[data-v-74d6cee6] {\n  min-width: 0;\n  min-height: 0;\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -ms-scroll-chaining: none;\n      overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n}", ""]);
// Exports
module.exports = exports;
